import type { ReactElement, ReactNode } from "react";
import { Avatar, Box, Grid, Typography } from "@mui/material";

interface AdministrationAreaProps {
  title?: string;
  icon?: string | ReactNode;
  items?: Array<ReactElement>;
  childrenSpacing?: number;
}
export function AdministrationArea({
  icon,
  title,
  items,
  childrenSpacing = 1,
}: Readonly<AdministrationAreaProps>): ReactNode {
  return (
    <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }}>
      <Typography
        variant="h3"
        sx={{ minHeight: "48px", marginBottom: 1, display: "flex", alignItems: "center" }}>
        {icon != null && <Avatar sx={{ mr: 1 }}>{icon}</Avatar>}
        {title}
      </Typography>
      {items?.map((child) => (
        <Box key={child.key} sx={{ mb: childrenSpacing }}>
          {child}
        </Box>
      ))}
    </Grid>
  );
}
